export default "__VITE_ASSET__Ml6n9yCX__"